import React from 'react';
import { Lock, Edit, Cog } from 'lucide-react';

/**
 * DataTypeChip Component
 * Displays data classification: System (immutable), Manual (editable), Derived (computed)
 */
const DataTypeChip = ({ type, size = 'sm' }) => {
  const configs = {
    system: {
      icon: Lock,
      label: 'System',
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      border: 'border-gray-300'
    },
    manual: {
      icon: Edit,
      label: 'Manual',
      bg: 'bg-green-100',
      text: 'text-green-700',
      border: 'border-green-300'
    },
    derived: {
      icon: Cog,
      label: 'Derived',
      bg: 'bg-purple-100',
      text: 'text-purple-700',
      border: 'border-purple-300'
    }
  };

  const config = configs[type] || configs.system;
  const Icon = config.icon;

  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5'
  };

  return (
    <span 
      className={`inline-flex items-center gap-1 rounded-full border ${config.bg} ${config.text} ${config.border} ${sizeClasses[size]} font-medium`}
      title={`Data Type: ${config.label}`}
    >
      <Icon size={size === 'xs' ? 10 : size === 'sm' ? 12 : 14} />
      <span>{config.label}</span>
    </span>
  );
};

export default DataTypeChip;
